'use strict';
import isFunction from 'lodash/isFunction';
import * as T from 'prop-types';
import React from 'react';
import {createEventHandler, mapPropsStream} from 'recompose';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/debounceTime';
import {createToggleState} from '../../../core-utilities/react-utils';
import {getDataTransferFiles} from '../../../core-utilities/upload-service/getDataTransferFiles';
import {RequirementItemView} from './RequirementItemView';


const StreamedComponent = (props$) => {
  const {
    handler: onCameraButtonClick,
    stream: cameraButtonClick$,
  } = createEventHandler();
  const {
    handler: onVideoButtonClick,
    stream: videoButtonClick$,
  } = createEventHandler();
  const {
    handler: onUploadButtonClick,
    stream: uploadButtonClick$,
  } = createEventHandler();
  const {
    handler: onUpIOSButtonClick,
    stream: upIOSButtonClick$,
  } = createEventHandler();
  const {
    handler: onDrop,
    stream: drop$,
  } = createEventHandler();
  const {
    handler: onToggleDragActive,
    stream: toggleDragActive$,
  } = createToggleState(props$);

  const onDragEnter = () => onToggleDragActive(true);
  const onDragLeave = () => onToggleDragActive(false);
  const onDragOver = event => {
    event.preventDefault();
    onToggleDragActive(true);
  };

  drop$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([event, props]) => {
      event.preventDefault();
      event.stopPropagation();

      onToggleDragActive(false);

      const files = getDataTransferFiles(event, true);

      if (props.isFileSelectEnabled(props.model.status)) {
        if (isFunction(props.onFileSelect)) {
          props.onFileSelect(event, props.model, files);
        }
      } else {
        if (isFunction(props.onFileSelectDenied)) {
          props.onFileSelectDenied(event, props.model);
        }
      }
    });

  cameraButtonClick$
    .withLatestFrom(props$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      if (isFunction(props.onCameraButtonClick)) {
        e.stopPropagation();
        if (props.isCameraButtonEnabled(props.model.status)) {
          props.onCameraButtonClick(e, props.model);
        }
      }
    });

  videoButtonClick$
    .withLatestFrom(props$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      if (isFunction(props.onVideoButtonClick)) {
        e.stopPropagation();
        if (props.isVideoButtonEnabled(props.model.status)) {
          props.onVideoButtonClick(e, props.model);
        }
      }
    });

  uploadButtonClick$
    .withLatestFrom(props$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      if (isFunction(props.onUploadButtonClick)) {
        e.stopPropagation();
        if (props.isUploadButtonEnabled(props.model.status)) {
          props.onUploadButtonClick(e, props.model);
        }
      }
    });

  upIOSButtonClick$
    .withLatestFrom(props$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      if (isFunction(props.onUpIOSButtonClick)) {
        e.stopPropagation();
        if (props.isUpIOSButtonEnabled(props.model.status)) {
          props.onUpIOSButtonClick(e, props.model);
        }
      }
    });

  return props$
    .combineLatest(
      toggleDragActive$,
      (props, isDragActive) => ({
        ...props,
        isDragging: isDragActive,
        enableCameraButton: props.isCameraButtonEnabled ? props.isCameraButtonEnabled(props.model.status) : false,
        enableVideoButton: props.isVideoButtonEnabled ? props.isVideoButtonEnabled(props.model.status) : false,
        enableUploadButton: props.isUploadButtonEnabled ? props.isUploadButtonEnabled(props.model.status) : false,
        enableIOSUpButton: props.isUpIOSButtonEnabled ? props.isUpIOSButtonEnabled(props.model.status) : false,
        onCameraButtonClick,
        onVideoButtonClick,
        onUploadButtonClick,
        onUpIOSButtonClick,
        onDragEnter,
        onDragLeave,
        onDragOver,
        onDrop,
      }));
};

export const RequirementItemComponent = mapPropsStream(StreamedComponent)(RequirementItemView);

RequirementItemComponent.propTypes = {
  userId: T.string.isRequired,
  model: T.object.isRequired,
  onClick: T.func.isRequired,
  onContextMenu: T.func.isRequired,
  showCameraButton: T.bool.isRequired,
  showVideoButton: T.bool.isRequired,
  isCameraButtonEnabled: T.func.isRequired,
  isVideoButtonEnabled: T.func.isRequired,
  onCameraButtonClick: T.func.isRequired,
  onVideoButtonClick: T.func.isRequired,
  showUploadButton: T.bool.isRequired,
  isUploadButtonEnabled: T.func.isRequired,
  onUploadButtonClick: T.func.isRequired,
  showIOSUpButton: T.bool.isRequired,
  isUpIOSButtonEnabled: T.func.isRequired,
  onUpIOSButtonClick: T.func.isRequired,
  isFileSelectEnabled: T.func.isRequired,
  onFileSelect: T.func.isRequired,
  onFileSelectDenied: T.func.isRequired,

  init: T.bool,
};

RequirementItemComponent.defaultProps = {
  isCameraButtonEnabled: () => true,
  isVideoButtonEnabled: () => true,
  isUploadButtonEnabled: () => true,
  isUpIOSButtonEnabled: () => true,
  isFileSelectEnabled: () => true,
  init: true,
};

RequirementItemComponent.messages = RequirementItemView.messages;
RequirementItemComponent.messageProps = RequirementItemView.messageProps;



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementItem/RequirementItemComponent.js